import { InjectionToken, Inject, ɵɵdefineInjectable, ɵɵinject, Injectable, TemplateRef, ViewContainerRef, Input, Directive, Component, NgModule } from '@angular/core';
import { __decorate, __param, __metadata } from 'tslib';
import { CacheService, RedirectService, SocietiesService, CommonModule, StringUtils } from '@pwc/common';
import { CookieService } from 'ngx-cookie-service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { BehaviorSubject, Subject, throwError, of } from 'rxjs';
import { map, tap, catchError, first, switchMap } from 'rxjs/operators';
import * as zxcvbn from 'zxcvbn';
import { enc, PBKDF2, AES, mode, pad } from 'crypto-js';
import { Keepalive } from '@ng-idle/keepalive';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { UIModule } from '@pwc/ui';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { TranslateService } from '@ngx-translate/core';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from 'ngx-cookie-service';
import * as ɵngcc3 from '@pwc/common';
import * as ɵngcc4 from '@ng-idle/core';
import * as ɵngcc5 from '@ng-idle/keepalive';
import * as ɵngcc6 from '@angular/common';
import * as ɵngcc7 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc8 from '@angular/router';
import * as ɵngcc9 from 'ngx-logger';
import * as ɵngcc10 from '@ngx-translate/core';

function PasswordMeterComponent_ngb_progressbar_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ngb-progressbar", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("type", ctx_r0.status)("value", ctx_r0.score);
} }
const CRYPTO_PARAMS = new InjectionToken('Crypto secret parameters');

class AuthenticationCookie {
}

var CookieName;
(function (CookieName) {
    CookieName["ACCESS"] = "cookie";
    CookieName["REFRESH"] = "refresh";
})(CookieName || (CookieName = {}));

let AuthenticationService = class AuthenticationService {
    constructor(http, cookieService, cache, redirectService, options) {
        this.http = http;
        this.cookieService = cookieService;
        this.cache = cache;
        this.redirectService = redirectService;
        this.options = options;
        this.cookieSubject = new BehaviorSubject(JSON.parse(null));
        this.cookie = this.cookieSubject.asObservable();
        this.logoutSubject = new Subject();
        this.logout$ = this.logoutSubject.asObservable();
        this.mustChangePasswordSubject = new BehaviorSubject(null);
        this.mustChangePassword$ = this.mustChangePasswordSubject.asObservable();
        this.userSubject = new BehaviorSubject(null);
        this.user$ = this.userSubject.asObservable();
        this.CURRENT_USER_CACHE_KEY = 'currentUser';
        this.LOGOUT_ENDPOINT = '/users/me/logout';
        console.debug('Read cookie');
        this.readCookie();
    }
    readCookie() {
        // if (this.cookieService.get(CookieName.ACCESS) !== '') {
        if (localStorage.getItem(CookieName.ACCESS) !== '') {
            console.debug('Cookie found, reading to cookieSubject');
            // this.cookieSubject.next(JSON.parse(this.cookieService.get(CookieName.ACCESS)));
            this.cookieSubject.next(JSON.parse(localStorage.getItem(CookieName.ACCESS)));
        }
    }
    getRefreshToken() {
        // if (this.cookieService.get(CookieName.REFRESH) !== '') {
        if (localStorage.getItem(CookieName.REFRESH) !== '') {
            // return JSON.parse(this.cookieService.get(CookieName.REFRESH)).refresh_token || null;
            return JSON.parse(localStorage.getItem(CookieName.REFRESH)).refresh_token || null;
        }
        return null;
    }
    setToken(token, refresh) {
        const cookie = new AuthenticationCookie();
        cookie.access_token = token;
        cookie.refresh_token = refresh || null;
        this.setCookie(cookie);
    }
    setCookie(cookie) {
        // this.cookieService.set(CookieName.ACCESS, JSON.stringify({
        //   access_token: cookie.access_token,
        //   expires_in: cookie.expires_in
        // }), 1, this.options.cookiePath, this.options.cookieDomain, this.options.secureFlag || false, 'Lax');
        //
        // this.cookieService.set(CookieName.REFRESH, JSON.stringify({refresh_token: cookie.refresh_token}), 1, this.options.cookiePath, this.options.cookieDomain, this.options.secureFlag || false, 'Lax');
        localStorage.setItem(CookieName.ACCESS, JSON.stringify({
            access_token: cookie.access_token,
            expires_in: cookie.expires_in
        }));
        localStorage.setItem(CookieName.REFRESH, JSON.stringify({ refresh_token: cookie.refresh_token }));
        this.cookieSubject.next(cookie);
    }
    get cookieValue() {
        if (this.cookieSubject.value == null) {
            this.readCookie();
        }
        return this.cookieSubject.value;
    }
    login(username, password) {
        const payload = new FormData();
        payload.append('username', username);
        payload.append('password', password);
        payload.append('grant_type', 'password');
        return this.getToken(payload);
    }
    loginOtp(token, code) {
        const payload = new FormData();
        payload.append('token', token);
        payload.append('code', code);
        payload.append('grant_type', 'otp');
        return this.getToken(payload);
    }
    refreshToken() {
        const refreshToken = this.getRefreshToken();
        if (refreshToken == null) {
            return throwError('Refresh token not found.');
        }
        console.debug('Refreshing token');
        const payload = new FormData();
        payload.append('refresh_token', refreshToken);
        payload.append('grant_type', 'refresh_token');
        return this.getToken(payload).pipe();
    }
    getToken(payload) {
        const headers = new HttpHeaders({
            Authorization: `Basic dGxzLWNsaWVudC1pZDp0bHMtY2xpZW50LXNlY3JldA==`
        });
        return this.http.post(`${this.options.url}/oauth/token`, payload, { headers })
            .pipe(map(res => {
            // login successful if there's a jwt token in the response
            if (res && res.access_token) {
                this.setCookie(res);
            }
            return res;
        }), tap(res => {
            if (res && res.refresh_token && res.expires_in) {
                if (res.expires_in < 10) {
                    console.debug('Refreshing token immediately.');
                    this.refreshToken();
                }
                else {
                    console.debug(`Scheduling refreshToken in ${res.expires_in - 10} seconds`);
                    setTimeout(() => {
                        console.debug('Refresh token now...');
                        this.refreshToken();
                    }, (res.expires_in - 10) * 1000);
                }
            }
        }), catchError((e) => {
            console.debug('getToken - error', e);
            /*if (e.status === 401) {
              this.logout();
            }*/
            return throwError(e);
        }));
    }
    resetDataUserCache() {
        this.cache.forget(this.CURRENT_USER_CACHE_KEY);
    }
    hasUserAcceptedTerms() {
        return this.http.get(`${this.options.url}/users/accepted-terms`);
    }
    dataUser() {
        if (this.cache.has(this.CURRENT_USER_CACHE_KEY)) {
            return of(this.cache.get(this.CURRENT_USER_CACHE_KEY));
        }
        return this.http.get(`${this.options.url}/users/me`)
            .pipe(tap((user) => {
            if (user != null && user.passwordExpire != null) {
                const now = new Date();
                const dateNow = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
                const expiration = new Date(new Date(user.passwordExpire).getUTCFullYear(), new Date(user.passwordExpire).getUTCMonth(), new Date(user.passwordExpire).getUTCDate());
                this.mustChangePasswordSubject.next(dateNow > expiration);
            }
            else {
                this.mustChangePasswordSubject.next(false);
            }
            this.userSubject.next(user);
        }), tap((user) => {
            this.cache.set(this.CURRENT_USER_CACHE_KEY, user);
        }));
    }
    logout(loginUrl) {
        // remove user from local storage to log user out
        localStorage.removeItem(CookieName.ACCESS);
        localStorage.removeItem(CookieName.REFRESH);
        this.cache.forget(this.CURRENT_USER_CACHE_KEY);
        const returnUrl = encodeURIComponent(window.location.href.split('?')[0].replace('login', ''));
        const baseUrl = loginUrl != null ? loginUrl : this.options.loginUrl;
        this.revokeAuthTokens()
            .pipe(first())
            .subscribe(success => {
            console.debug('revokeToken success', success);
            window.location.href = `${baseUrl}/login?returnUrl=${returnUrl}`;
        }, error => {
            console.error(error);
            window.location.href = `${baseUrl}/login?returnUrl=${returnUrl}`;
        });
    }
    revokeToken() {
        this.revokeAuthTokens()
            .pipe(first())
            .subscribe(success => {
            console.debug('revokeToken success', success);
        }, error => {
            console.error(error);
        });
    }
    revokeAuthTokens() {
        return this.http.post(`${this.options.url}${this.LOGOUT_ENDPOINT}`, {})
            .pipe(first(), catchError((e) => {
            console.debug('revokeTokens', e);
            return of(null);
        }));
    }
    customerProfilesUser() {
        return this.http.get(`${this.options.url}/users/me/roles?type=PRIMARY`);
    }
    checkAdmin() {
        this.customerProfilesUser()
            .pipe(first())
            .subscribe(data => {
            const admin = data.filter(p => p.groupCode.toLowerCase() === 'super_user' || p.groupCode.toLowerCase() === 'pwc_super_user').length > 0;
        }, error => {
            console.error(error);
        });
    }
    forgotPassword(email) {
        const payload = new FormData();
        payload.append('email', email);
        const headers = new HttpHeaders({
            Authorization: `Basic dGxzLWNsaWVudC1pZDp0bHMtY2xpZW50LXNlY3JldA==`
        });
        return this.http.post(`${this.options.url}/registration/forgot-password`, payload, { headers })
            .pipe(map(res => {
            // login successful if there's a jwt token in the response
            console.log('RES', res);
            return res;
        }));
    }
    resetPassword(token, password) {
        const payload = new FormData();
        payload.append('password', password);
        payload.append('token', token);
        const headers = new HttpHeaders({
            Authorization: `Basic dGxzLWNsaWVudC1pZDp0bHMtY2xpZW50LXNlY3JldA==`
        });
        return this.http.post(`${this.options.url}/registration/reset-password`, payload, { headers })
            .pipe(map(res => {
            console.log('RES', res);
            return res;
        }));
    }
    navigateToChangePassword() {
        window.location.href = `${this.options.frontendUrl}/account/change-password`;
    }
};
AuthenticationService.ɵfac = function AuthenticationService_Factory(t) { return new (t || AuthenticationService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.CookieService), ɵngcc0.ɵɵinject(ɵngcc3.CacheService), ɵngcc0.ɵɵinject(ɵngcc3.RedirectService), ɵngcc0.ɵɵinject('AUTH_OPTIONS')); };
AuthenticationService.ctorParameters = () => [
    { type: HttpClient },
    { type: CookieService },
    { type: CacheService },
    { type: RedirectService },
    { type: undefined, decorators: [{ type: Inject, args: ['AUTH_OPTIONS',] }] }
];
AuthenticationService.ɵprov = ɵɵdefineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(ɵɵinject(HttpClient), ɵɵinject(CookieService), ɵɵinject(CacheService), ɵɵinject(RedirectService), ɵɵinject("AUTH_OPTIONS")); }, token: AuthenticationService, providedIn: "root" });
AuthenticationService = __decorate([ __param(4, Inject('AUTH_OPTIONS')),
    __metadata("design:paramtypes", [HttpClient,
        CookieService,
        CacheService,
        RedirectService, Object])
], AuthenticationService);

let AuthorizationService = class AuthorizationService {
    constructor(http, societiesService, options) {
        this.http = http;
        this.societiesService = societiesService;
        this.options = options;
        this.endpoint = 'users/me';
        this.cacheSubject = new BehaviorSubject(null);
        this.cache$ = this.cacheSubject.asObservable();
        this.societiesService.getSelectedSociety()
            .pipe(tap(society => {
            this.cache = null;
        }));
    }
    getAuthorities(clearCache = false) {
        if (!clearCache && this.cacheSubject.getValue() != null) {
            return this.cache$;
        }
        return this.societiesService.currentSociety$
            .pipe(switchMap((society) => {
            if (society == null) {
                return this.http.get(`${this.options.url}/${this.endpoint}/authorities`);
            }
            return this.http.get(`${this.options.url}/${this.endpoint}/authorities/${society.id}`);
        }), tap((authorities) => {
            this.cacheSubject.next(authorities);
        }));
    }
    checkAuthorities(authorities) {
        return this.cache$
            .pipe(switchMap((list) => {
            if (list == null) {
                return this.getAuthorities();
            }
            return of(list);
        }), switchMap((list) => {
            if (typeof authorities === 'string') {
                authorities = [authorities];
            }
            //  No required authorities => grant access
            if (authorities.length === 0) {
                return of(true);
            }
            //  No granted authorities => deny access
            if (list.length === 0) {
                return of(false);
            }
            const granted = list.map((authority) => authority.code);
            return of(this.hasAnyAuthority(granted, authorities));
        }));
    }
    hasAnyAuthority(granted, required) {
        for (const authority of required) {
            if (granted.indexOf(authority) > -1) {
                return true;
            }
        }
        return false;
    }
};
AuthorizationService.ɵfac = function AuthorizationService_Factory(t) { return new (t || AuthorizationService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc3.SocietiesService), ɵngcc0.ɵɵinject('AUTH_OPTIONS')); };
AuthorizationService.ctorParameters = () => [
    { type: HttpClient },
    { type: SocietiesService },
    { type: undefined, decorators: [{ type: Inject, args: ['AUTH_OPTIONS',] }] }
];
AuthorizationService.ɵprov = ɵɵdefineInjectable({ factory: function AuthorizationService_Factory() { return new AuthorizationService(ɵɵinject(HttpClient), ɵɵinject(SocietiesService), ɵɵinject("AUTH_OPTIONS")); }, token: AuthorizationService, providedIn: "root" });
AuthorizationService = __decorate([ __param(2, Inject('AUTH_OPTIONS')),
    __metadata("design:paramtypes", [HttpClient,
        SocietiesService, Object])
], AuthorizationService);

let PasswordStrengthService = class PasswordStrengthService {
    checkPassword(password) {
        const result = zxcvbn(password);
        return {
            score: result.score,
            feedback: result.feedback
        };
    }
};
PasswordStrengthService.ɵfac = function PasswordStrengthService_Factory(t) { return new (t || PasswordStrengthService)(); };
PasswordStrengthService.ɵprov = ɵɵdefineInjectable({ factory: function PasswordStrengthService_Factory() { return new PasswordStrengthService(); }, token: PasswordStrengthService, providedIn: "root" });

let CryptoService = class CryptoService {
    constructor(params) {
        this.params = params;
    }
    encryptToString(source) {
        const salt = enc.Hex.parse(this.params.salt);
        const iv = enc.Hex.parse(this.params.iv);
        const key = PBKDF2(this.params.secret, salt, {
            keySize: 256 / 32,
            iterations: 100
        });
        return AES.encrypt(source, key, {
            iv,
            mode: mode.CBC,
            padding: pad.Pkcs7
        }).toString();
    }
    decryptToString(source) {
        const salt = enc.Hex.parse(this.params.salt);
        const iv = enc.Hex.parse(this.params.iv);
        const key = PBKDF2(this.params.secret, salt, {
            keySize: 256 / 32,
            iterations: 100
        });
        return AES.decrypt(source, key, {
            iv,
            mode: mode.CBC,
            padding: pad.Pkcs7
        }).toString();
    }
};
CryptoService.ɵfac = function CryptoService_Factory(t) { return new (t || CryptoService)(ɵngcc0.ɵɵinject(CRYPTO_PARAMS)); };
CryptoService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [CRYPTO_PARAMS,] }] }
];
CryptoService.ɵprov = ɵɵdefineInjectable({ factory: function CryptoService_Factory() { return new CryptoService(ɵɵinject(CRYPTO_PARAMS)); }, token: CryptoService, providedIn: "root" });
CryptoService = __decorate([ __param(0, Inject(CRYPTO_PARAMS)),
    __metadata("design:paramtypes", [Object])
], CryptoService);

let PasswordValidationFrontendService = class PasswordValidationFrontendService {
    constructor() {
        this.result = [];
        this.set = new Set();
        this.alphabetSequence = ['abcdefghijklmnopqrstuvwxyz', 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];
        this.quertySequence = ['`1234567890-=', '~!@#$%^&*()_+', '\u0000¡™£¢∞§¶•ªº–≠', '`⁄€‹›ﬁﬂ‡°·,—±', 'qwertyuiop[]\\',
            'QWERTYUIOP{}|', 'œ∑\u0000®†¥\u0000\u0000øπ“‘«', 'Œ„´‰ˇÁ¨ˆØ∏”’»', 'asdfghjkl;\'', 'ASDFGHJKL:"', 'åß∂ƒ©˙∆˚¬…æ',
            'ÅÍÎÏ˝ÓÔ\uf8ffÒÚÆ', 'zxcvbnm,./', 'ZXCVBNM<>?', 'Ω≈ç√∫\u0000µ≤≥÷', '¸˛Ç◊ı˜Â¯˘¿'];
        this.digitSequence = '0123456789';
        // FRAMEWORK BLACK LISTS
        this.blackListDigits = ['0123456789', '123456789', '23456789', '3456789', '456789', '56789', '45678', '34567', '345678', '23456',
            '234567', '2345678', '12345', '123456', '1234567', '12345678', '01234', '012345', '0123456', '01234567', '012345678'];
        this.blackListAlphabet = ['abcdefghijklmnopqrstuvwxyz', 'bcdefghijklmnopqrstuvwxyz', 'cdefghijklmnopqrstuvwxyz', 'defghijklmnopqrstuvwxyz', 'efghijklmnopqrstuvwxyz', 'fghijklmnopqrstuvwxyz', 'ghijklmnopqrstuvwxyz', 'hijklmnopqrstuvwxyz', 'ijklmnopqrstuvwxyz', 'jklmnopqrstuvwxyz', 'klmnopqrstuvwxyz', 'lmnopqrstuvwxyz', 'mnopqrstuvwxyz', 'nopqrstuvwxyz', 'opqrstuvwxyz', 'pqrstuvwxyz', 'qrstuvwxyz', 'rstuvwxyz', 'stuvwxyz', 'tuvwxyz', 'uvwxyz', 'vwxyz', 'uvwxy', 'tuvwx', 'tuvwxy', 'stuvw', 'stuvwx', 'stuvwxy', 'rstuv', 'rstuvw', 'rstuvwx', 'rstuvwxy', 'qrstu', 'qrstuv', 'qrstuvw', 'qrstuvwx', 'qrstuvwxy', 'pqrst', 'pqrstu', 'pqrstuv', 'pqrstuvw', 'pqrstuvwx', 'pqrstuvwxy', 'opqrs', 'opqrst', 'opqrstu', 'opqrstuv', 'opqrstuvw', 'opqrstuvwx', 'opqrstuvwxy', 'nopqr', 'nopqrs', 'nopqrst', 'nopqrstu', 'nopqrstuv', 'nopqrstuvw', 'nopqrstuvwx', 'nopqrstuvwxy', 'mnopq', 'mnopqr', 'mnopqrs', 'mnopqrst', 'mnopqrstu', 'mnopqrstuv', 'mnopqrstuvw', 'mnopqrstuvwx', 'mnopqrstuvwxy', 'lmnop', 'lmnopq', 'lmnopqr', 'lmnopqrs', 'lmnopqrst', 'lmnopqrstu', 'lmnopqrstuv', 'lmnopqrstuvw', 'lmnopqrstuvwx', 'lmnopqrstuvwxy', 'klmno', 'klmnop', 'klmnopq', 'klmnopqr', 'klmnopqrs', 'klmnopqrst', 'klmnopqrstu', 'klmnopqrstuv', 'klmnopqrstuvw', 'klmnopqrstuvwx', 'klmnopqrstuvwxy', 'jklmn', 'jklmno', 'jklmnop', 'jklmnopq', 'jklmnopqr', 'jklmnopqrs', 'jklmnopqrst', 'jklmnopqrstu', 'jklmnopqrstuv', 'jklmnopqrstuvw', 'jklmnopqrstuvwx', 'jklmnopqrstuvwxy', 'ijklm', 'ijklmn', 'ijklmno', 'ijklmnop', 'ijklmnopq', 'ijklmnopqr', 'ijklmnopqrs', 'ijklmnopqrst', 'ijklmnopqrstu', 'ijklmnopqrstuv', 'ijklmnopqrstuvw', 'ijklmnopqrstuvwx', 'ijklmnopqrstuvwxy', 'hijkl', 'hijklm', 'hijklmn', 'hijklmno', 'hijklmnop', 'hijklmnopq', 'hijklmnopqr', 'hijklmnopqrs', 'hijklmnopqrst', 'hijklmnopqrstu', 'hijklmnopqrstuv', 'hijklmnopqrstuvw', 'hijklmnopqrstuvwx', 'hijklmnopqrstuvwxy', 'ghijk', 'ghijkl', 'ghijklm', 'ghijklmn', 'ghijklmno', 'ghijklmnop', 'ghijklmnopq', 'ghijklmnopqr', 'ghijklmnopqrs', 'ghijklmnopqrst', 'ghijklmnopqrstu', 'ghijklmnopqrstuv', 'ghijklmnopqrstuvw', 'ghijklmnopqrstuvwx', 'ghijklmnopqrstuvwxy', 'fghij', 'fghijk', 'fghijkl', 'fghijklm', 'fghijklmn', 'fghijklmno', 'fghijklmnop', 'fghijklmnopq', 'fghijklmnopqr', 'fghijklmnopqrs', 'fghijklmnopqrst', 'fghijklmnopqrstu', 'fghijklmnopqrstuv', 'fghijklmnopqrstuvw', 'fghijklmnopqrstuvwx', 'fghijklmnopqrstuvwxy', 'efghi', 'efghij', 'efghijk', 'efghijkl', 'efghijklm', 'efghijklmn', 'efghijklmno', 'efghijklmnop', 'efghijklmnopq', 'efghijklmnopqr', 'efghijklmnopqrs', 'efghijklmnopqrst', 'efghijklmnopqrstu', 'efghijklmnopqrstuv', 'efghijklmnopqrstuvw', 'efghijklmnopqrstuvwx', 'efghijklmnopqrstuvwxy', 'defgh', 'defghi', 'defghij', 'defghijk', 'defghijkl', 'defghijklm', 'defghijklmn', 'defghijklmno', 'defghijklmnop', 'defghijklmnopq', 'defghijklmnopqr', 'defghijklmnopqrs', 'defghijklmnopqrst', 'defghijklmnopqrstu', 'defghijklmnopqrstuv', 'defghijklmnopqrstuvw', 'defghijklmnopqrstuvwx', 'defghijklmnopqrstuvwxy', 'cdefg', 'cdefgh', 'cdefghi', 'cdefghij', 'cdefghijk', 'cdefghijkl', 'cdefghijklm', 'cdefghijklmn', 'cdefghijklmno', 'cdefghijklmnop', 'cdefghijklmnopq', 'cdefghijklmnopqr', 'cdefghijklmnopqrs', 'cdefghijklmnopqrst', 'cdefghijklmnopqrstu', 'cdefghijklmnopqrstuv', 'cdefghijklmnopqrstuvw', 'cdefghijklmnopqrstuvwx', 'cdefghijklmnopqrstuvwxy', 'bcdef', 'bcdefg', 'bcdefgh', 'bcdefghi', 'bcdefghij', 'bcdefghijk', 'bcdefghijkl', 'bcdefghijklm', 'bcdefghijklmn', 'bcdefghijklmno', 'bcdefghijklmnop', 'bcdefghijklmnopq', 'bcdefghijklmnopqr', 'bcdefghijklmnopqrs', 'bcdefghijklmnopqrst', 'bcdefghijklmnopqrstu', 'bcdefghijklmnopqrstuv', 'bcdefghijklmnopqrstuvw', 'bcdefghijklmnopqrstuvwx', 'bcdefghijklmnopqrstuvwxy', 'abcde', 'abcdef', 'abcdefg', 'abcdefgh', 'abcdefghi', 'abcdefghij', 'abcdefghijk', 'abcdefghijkl', 'abcdefghijklm', 'abcdefghijklmn', 'abcdefghijklmno', 'abcdefghijklmnop', 'abcdefghijklmnopq', 'abcdefghijklmnopqr', 'abcdefghijklmnopqrs', 'abcdefghijklmnopqrst', 'abcdefghijklmnopqrstu', 'abcdefghijklmnopqrstuv', 'abcdefghijklmnopqrstuvw', 'abcdefghijklmnopqrstuvwx', 'abcdefghijklmnopqrstuvwxy'];
        this.blackListQuerty = ['`1234567890-=', '1234567890-=', '234567890-=', '34567890-=', '4567890-=', '567890-=', '67890-=', '7890-=', '890-=', '7890-', '67890', '67890-', '56789', '567890', '567890-', '45678', '456789', '4567890', '4567890-', '34567', '345678', '3456789', '34567890', '34567890-', '23456', '234567', '2345678', '23456789', '234567890', '234567890-', '12345', '123456', '1234567', '12345678', '123456789', '1234567890', '1234567890-', '`1234', '`12345', '`123456', '`1234567', '`12345678', '`123456789', '`1234567890', '`1234567890-',
            '~!@#$%^&*()_+', '!@#$%^&*()_+', '@#$%^&*()_+', '#$%^&*()_+', '$%^&*()_+', '%^&*()_+', '^&*()_+', '&*()_+', '*()_+', '&*()_', '^&*()', '^&*()_', '%^&*(', '%^&*()', '%^&*()_', '$%^&*', '$%^&*(', '$%^&*()', '$%^&*()_', '#$%^&', '#$%^&*', '#$%^&*(', '#$%^&*()', '#$%^&*()_', '@#$%^', '@#$%^&', '@#$%^&*', '@#$%^&*(', '@#$%^&*()', '@#$%^&*()_', '!@#$%', '!@#$%^', '!@#$%^&', '!@#$%^&*', '!@#$%^&*(', '!@#$%^&*()', '!@#$%^&*()_', '~!@#$', '~!@#$%', '~!@#$%^', '~!@#$%^&', '~!@#$%^&*', '~!@#$%^&*(', '~!@#$%^&*()', '~!@#$%^&*()_',
            '¡™£¢∞§¶•ªº–≠', '¡™£¢∞§¶•ªº–≠', '™£¢∞§¶•ªº–≠', '£¢∞§¶•ªº–≠', '¢∞§¶•ªº–≠', '∞§¶•ªº–≠', '§¶•ªº–≠', '¶•ªº–≠', '•ªº–≠', '¶•ªº–', '§¶•ªº', '§¶•ªº–', '∞§¶•ª', '∞§¶•ªº', '∞§¶•ªº–', '¢∞§¶•', '¢∞§¶•ª', '¢∞§¶•ªº', '¢∞§¶•ªº–', '£¢∞§¶', '£¢∞§¶•', '£¢∞§¶•ª', '£¢∞§¶•ªº', '£¢∞§¶•ªº–', '™£¢∞§', '™£¢∞§¶', '™£¢∞§¶•', '™£¢∞§¶•ª', '™£¢∞§¶•ªº', '™£¢∞§¶•ªº–', '¡™£¢∞', '¡™£¢∞§', '¡™£¢∞§¶', '¡™£¢∞§¶•', '¡™£¢∞§¶•ª', '¡™£¢∞§¶•ªº', '¡™£¢∞§¶•ªº–', '¡™£¢', '¡™£¢∞', '¡™£¢∞§', '¡™£¢∞§¶', '¡™£¢∞§¶•', '¡™£¢∞§¶•ª', '¡™£¢∞§¶•ªº', '¡™£¢∞§¶•ªº–',
            '`⁄€‹›ﬁﬂ‡°·,—±', '⁄€‹›ﬁﬂ‡°·,—±', '€‹›ﬁﬂ‡°·,—±', '‹›ﬁﬂ‡°·,—±', '›ﬁﬂ‡°·,—±', 'ﬁﬂ‡°·,—±', 'ﬂ‡°·,—±', '‡°·,—±', '°·,—±', '‡°·,—', 'ﬂ‡°·,', 'ﬂ‡°·,—', 'ﬁﬂ‡°·', 'ﬁﬂ‡°·,', 'ﬁﬂ‡°·,—', '›ﬁﬂ‡°', '›ﬁﬂ‡°·', '›ﬁﬂ‡°·,', '›ﬁﬂ‡°·,—', '‹›ﬁﬂ‡', '‹›ﬁﬂ‡°', '‹›ﬁﬂ‡°·', '‹›ﬁﬂ‡°·,', '‹›ﬁﬂ‡°·,—', '€‹›ﬁﬂ', '€‹›ﬁﬂ‡', '€‹›ﬁﬂ‡°', '€‹›ﬁﬂ‡°·', '€‹›ﬁﬂ‡°·,', '€‹›ﬁﬂ‡°·,—', '⁄€‹›ﬁ', '⁄€‹›ﬁﬂ', '⁄€‹›ﬁﬂ‡', '⁄€‹›ﬁﬂ‡°', '⁄€‹›ﬁﬂ‡°·', '⁄€‹›ﬁﬂ‡°·,', '⁄€‹›ﬁﬂ‡°·,—', '`⁄€‹›', '`⁄€‹›ﬁ', '`⁄€‹›ﬁﬂ', '`⁄€‹›ﬁﬂ‡', '`⁄€‹›ﬁﬂ‡°', '`⁄€‹›ﬁﬂ‡°·', '`⁄€‹›ﬁﬂ‡°·,', '`⁄€‹›ﬁﬂ‡°·,—',
            'qwertyuiop[]\\', 'wertyuiop[]\\', 'ertyuiop[]\\', 'rtyuiop[]\\', 'tyuiop[]\\', 'yuiop[]\\', 'uiop[]\\', 'iop[]\\', 'op[]\\', 'iop[]', 'uiop[', 'uiop[]', 'yuiop', 'yuiop[', 'yuiop[]', 'tyuio', 'tyuiop', 'tyuiop[', 'tyuiop[]', 'rtyui', 'rtyuio', 'rtyuiop', 'rtyuiop[', 'rtyuiop[]', 'ertyu', 'ertyui', 'ertyuio', 'ertyuiop', 'ertyuiop[', 'ertyuiop[]', 'werty', 'wertyu', 'wertyui', 'wertyuio', 'wertyuiop', 'wertyuiop[', 'wertyuiop[]', 'qwert', 'qwerty', 'qwertyu', 'qwertyui', 'qwertyuio', 'qwertyuiop', 'qwertyuiop[', 'qwertyuiop[]',
            'QWERTYUIOP{}|', 'WERTYUIOP{}|', 'ERTYUIOP{}|', 'RTYUIOP{}|', 'TYUIOP{}|', 'YUIOP{}|', 'UIOP{}|', 'IOP{}|', 'OP{}|', 'IOP{}', 'UIOP{', 'UIOP{}', 'YUIOP', 'YUIOP{', 'YUIOP{}', 'TYUIO', 'TYUIOP', 'TYUIOP{', 'TYUIOP{}', 'RTYUI', 'RTYUIO', 'RTYUIOP', 'RTYUIOP{', 'RTYUIOP{}', 'ERTYU', 'ERTYUI', 'ERTYUIO', 'ERTYUIOP', 'ERTYUIOP{', 'ERTYUIOP{}', 'WERTY', 'WERTYU', 'WERTYUI', 'WERTYUIO', 'WERTYUIOP', 'WERTYUIOP{', 'WERTYUIOP{}', 'QWERT', 'QWERTY', 'QWERTYU', 'QWERTYUI', 'QWERTYUIO', 'QWERTYUIOP', 'QWERTYUIOP{', 'QWERTYUIOP{}',
            'œ∑®†¥øπ“‘«', '∑®†¥øπ“‘«', '®†¥øπ“‘«', '®†¥øπ“‘«', '†¥øπ“‘«', '¥øπ“‘«', 'øπ“‘«', 'øπ“‘«', 'øπ“‘«', 'øπ“‘', 'øπ“', 'øπ“‘', '¥øπ', '¥øπ“', '¥øπ“‘', '†¥ø', '†¥øπ', '†¥øπ“', '†¥øπ“‘', '®†¥', '®†¥ø', '®†¥øπ', '®†¥øπ“', '®†¥øπ“‘', '®†¥', '®†¥', '®†¥ø', '®†¥øπ', '®†¥øπ“', '®†¥øπ“‘', '∑®†¥', '∑®†¥', '∑®†¥', '∑®†¥ø', '∑®†¥øπ', '∑®†¥øπ“', '∑®†¥øπ“‘', 'œ∑®†', 'œ∑®†¥', 'œ∑®†¥', 'œ∑®†¥', 'œ∑®†¥ø', 'œ∑®†¥øπ', 'œ∑®†¥øπ“', 'œ∑®†¥øπ“‘',
            'Œ„´‰ˇÁ¨ˆØ∏”’»', '„´‰ˇÁ¨ˆØ∏”’»', '´‰ˇÁ¨ˆØ∏”’»', '‰ˇÁ¨ˆØ∏”’»', 'ˇÁ¨ˆØ∏”’»', 'Á¨ˆØ∏”’»', '¨ˆØ∏”’»', 'ˆØ∏”’»', 'Ø∏”’»', 'ˆØ∏”’', '¨ˆØ∏”', '¨ˆØ∏”’', 'Á¨ˆØ∏', 'Á¨ˆØ∏”', 'Á¨ˆØ∏”’', 'ˇÁ¨ˆØ', 'ˇÁ¨ˆØ∏', 'ˇÁ¨ˆØ∏”', 'ˇÁ¨ˆØ∏”’', '‰ˇÁ¨ˆ', '‰ˇÁ¨ˆØ', '‰ˇÁ¨ˆØ∏', '‰ˇÁ¨ˆØ∏”', '‰ˇÁ¨ˆØ∏”’', '´‰ˇÁ¨', '´‰ˇÁ¨ˆ', '´‰ˇÁ¨ˆØ', '´‰ˇÁ¨ˆØ∏', '´‰ˇÁ¨ˆØ∏”', '´‰ˇÁ¨ˆØ∏”’', '„´‰ˇÁ', '„´‰ˇÁ¨', '„´‰ˇÁ¨ˆ', '„´‰ˇÁ¨ˆØ', '„´‰ˇÁ¨ˆØ∏', '„´‰ˇÁ¨ˆØ∏”', '„´‰ˇÁ¨ˆØ∏”’', 'Œ„´‰ˇ', 'Œ„´‰ˇÁ', 'Œ„´‰ˇÁ¨', 'Œ„´‰ˇÁ¨ˆ', 'Œ„´‰ˇÁ¨ˆØ', 'Œ„´‰ˇÁ¨ˆØ∏', 'Œ„´‰ˇÁ¨ˆØ∏”', 'Œ„´‰ˇÁ¨ˆØ∏”’',
            'asdfghjkl;\'', 'sdfghjkl;\'', 'dfghjkl;\'', 'fghjkl;\'', 'ghjkl;\'', 'hjkl;\'', 'jkl;\'', 'hjkl;', 'ghjkl', 'ghjkl;', 'fghjk', 'fghjkl', 'fghjkl;', 'dfghj', 'dfghjk', 'dfghjkl', 'dfghjkl;', 'sdfgh', 'sdfghj', 'sdfghjk', 'sdfghjkl', 'sdfghjkl;', 'asdfg', 'asdfgh', 'asdfghj', 'asdfghjk', 'asdfghjkl', 'asdfghjkl;',
            'ASDFGHJKL:"', 'SDFGHJKL:"', 'DFGHJKL:"', 'FGHJKL:"', 'GHJKL:"', 'HJKL:"', 'JKL:"', 'HJKL:', 'GHJKL', 'GHJKL:', 'FGHJK', 'FGHJKL', 'FGHJKL:', 'DFGHJ', 'DFGHJK', 'DFGHJKL', 'DFGHJKL:', 'SDFGH', 'SDFGHJ', 'SDFGHJK', 'SDFGHJKL', 'SDFGHJKL:', 'ASDFG', 'ASDFGH', 'ASDFGHJ', 'ASDFGHJK', 'ASDFGHJKL', 'ASDFGHJKL:',
            'åß∂ƒ©˙∆˚¬…æ', 'ß∂ƒ©˙∆˚¬…æ', '∂ƒ©˙∆˚¬…æ', 'ƒ©˙∆˚¬…æ', '©˙∆˚¬…æ', '˙∆˚¬…æ', '∆˚¬…æ', '˙∆˚¬…', '©˙∆˚¬', '©˙∆˚¬…', 'ƒ©˙∆˚', 'ƒ©˙∆˚¬', 'ƒ©˙∆˚¬…', '∂ƒ©˙∆', '∂ƒ©˙∆˚', '∂ƒ©˙∆˚¬', '∂ƒ©˙∆˚¬…', 'ß∂ƒ©˙', 'ß∂ƒ©˙∆', 'ß∂ƒ©˙∆˚', 'ß∂ƒ©˙∆˚¬', 'ß∂ƒ©˙∆˚¬…', 'åß∂ƒ©', 'åß∂ƒ©˙', 'åß∂ƒ©˙∆', 'åß∂ƒ©˙∆˚', 'åß∂ƒ©˙∆˚¬', 'åß∂ƒ©˙∆˚¬…',
            'ÅÍÎÏ˝ÓÔÒÚÆ', 'ÍÎÏ˝ÓÔÒÚÆ', 'ÎÏ˝ÓÔÒÚÆ', 'Ï˝ÓÔÒÚÆ', '˝ÓÔÒÚÆ', 'ÓÔÒÚÆ', 'ÔÒÚÆ', 'ÓÔÒÚ', '˝ÓÔÒ', '˝ÓÔÒÚ', 'Ï˝ÓÔ', 'Ï˝ÓÔÒ', 'Ï˝ÓÔÒÚ', 'ÎÏ˝ÓÔ', 'ÎÏ˝ÓÔ', 'ÎÏ˝ÓÔÒ', 'ÎÏ˝ÓÔÒÚ', 'ÍÎÏ˝Ó', 'ÍÎÏ˝ÓÔ', 'ÍÎÏ˝ÓÔ', 'ÍÎÏ˝ÓÔÒ', 'ÍÎÏ˝ÓÔÒÚ', 'ÅÍÎÏ˝', 'ÅÍÎÏ˝Ó', 'ÅÍÎÏ˝ÓÔ', 'ÅÍÎÏ˝ÓÔ', 'ÅÍÎÏ˝ÓÔÒ', 'ÅÍÎÏ˝ÓÔÒÚ',
            'zxcvbnm,./', 'xcvbnm,./', 'cvbnm,./', 'vbnm,./', 'bnm,./', 'nm,./', 'bnm,.', 'vbnm,', 'vbnm,.', 'cvbnm', 'cvbnm,', 'cvbnm,.', 'xcvbn', 'xcvbnm', 'xcvbnm,', 'xcvbnm,.', 'zxcvb', 'zxcvbn', 'zxcvbnm', 'zxcvbnm,', 'zxcvbnm,.',
            'ZXCVBNM<>?', 'XCVBNM<>?', 'CVBNM<>?', 'VBNM<>?', 'BNM<>?', 'NM<>?', 'BNM<>', 'VBNM<', 'VBNM<>', 'CVBNM', 'CVBNM<', 'CVBNM<>', 'XCVBN', 'XCVBNM', 'XCVBNM<', 'XCVBNM<>', 'ZXCVB', 'ZXCVBN', 'ZXCVBNM', 'ZXCVBNM<', 'ZXCVBNM<>',
            'Ω≈ç√∫µ≤≥÷', '≈ç√∫µ≤≥÷', 'ç√∫µ≤≥÷', '√∫µ≤≥÷', '∫µ≤≥÷', 'µ≤≥÷', '∫µ≤≥', '√∫µ≤', '√∫µ≤≥', 'ç√∫µ', 'ç√∫µ≤', 'ç√∫µ≤≥', '≈ç√∫', '≈ç√∫µ', '≈ç√∫µ≤', '≈ç√∫µ≤≥', 'Ω≈ç√∫', 'Ω≈ç√∫', 'Ω≈ç√∫µ', 'Ω≈ç√∫µ≤', 'Ω≈ç√∫µ≤≥',
            '¸˛Ç◊ı˜Â¯˘¿', '˛Ç◊ı˜Â¯˘¿', 'Ç◊ı˜Â¯˘¿', '◊ı˜Â¯˘¿', 'ı˜Â¯˘¿', '˜Â¯˘¿', 'ı˜Â¯˘', '◊ı˜Â¯', '◊ı˜Â¯˘', 'Ç◊ı˜Â', 'Ç◊ı˜Â¯', 'Ç◊ı˜Â¯˘', '˛Ç◊ı˜', '˛Ç◊ı˜Â', '˛Ç◊ı˜Â¯', '˛Ç◊ı˜Â¯˘', '¸˛Ç◊ı', '¸˛Ç◊ı˜', '¸˛Ç◊ı˜Â', '¸˛Ç◊ı˜Â¯', '¸˛Ç◊ı˜Â¯˘'];
    }
    isPasswordValid(password, username, firstName, lastName) {
        if (!password || !username || !firstName || !lastName) {
            return false;
        }
        // regex for: minimum 8 chars, at least one char lowercase and uppercase, at least one digit,
        // at least one special char, no whitespaces
        const matchChars = password.match(`^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})`);
        // not 'pwd' or 'admin' or 'password' or username or firstname or lastname
        const matchTrivialWords = password.toLowerCase().match(`^((?!(pwd)|(admin)|(password)|( )|(${username.toLowerCase()})|(${firstName.toLowerCase()})|(${lastName.toLowerCase()})).)*$`);
        if (matchChars && matchTrivialWords && matchChars.length > 0 && matchTrivialWords.length > 0) {
            let valid = true;
            // check blackLists
            const blackList = this.blackListAlphabet.concat(this.blackListDigits).concat(this.blackListQuerty);
            blackList.forEach((item) => {
                if (password.indexOf(item) > 0) {
                    valid = false;
                    return false;
                }
            });
            return valid;
        }
        else {
            return false;
        }
    }
    // UTILITY METHOD TO BUILD BLACK LISTS
    buildBlackList(minimumWordSize) {
        const str = this.quertySequence[15];
        const ans = this.splitAllWays([], [], str);
        ans.forEach((item, index) => {
            const arr = item.filter((it) => it.length >= minimumWordSize);
            arr.forEach((it) => { this.set.add(it); });
        });
        this.set.forEach((item) => this.result.push(item));
        console.log(this.set);
    }
    // Split string into all combinations possible
    splitAllWays(result, left, right) {
        // Push current left + right to the result list
        result.push(left.concat(right));
        // If we still have chars to work with in the right side then keep splitting
        if (right.length > 1) {
            // For each combination left/right split call splitAllWays()
            for (let i = 1; i < right.length; i++) {
                this.splitAllWays(result, left.concat(right.substring(0, i)), right.substring(i));
            }
        }
        // Return result
        return result;
    }
};
PasswordValidationFrontendService.ɵfac = function PasswordValidationFrontendService_Factory(t) { return new (t || PasswordValidationFrontendService)(); };
PasswordValidationFrontendService.ɵprov = ɵɵdefineInjectable({ factory: function PasswordValidationFrontendService_Factory() { return new PasswordValidationFrontendService(); }, token: PasswordValidationFrontendService, providedIn: "root" });
PasswordValidationFrontendService = __decorate([ __metadata("design:paramtypes", [])
], PasswordValidationFrontendService);

var IDLE_ENUM;
(function (IDLE_ENUM) {
    IDLE_ENUM[IDLE_ENUM["NOT_STARTED"] = 0] = "NOT_STARTED";
    IDLE_ENUM[IDLE_ENUM["STARTED"] = 1] = "STARTED";
    IDLE_ENUM[IDLE_ENUM["IDLE"] = 2] = "IDLE";
    IDLE_ENUM[IDLE_ENUM["NOT_IDLE"] = 3] = "NOT_IDLE";
    IDLE_ENUM[IDLE_ENUM["TIMEOUT"] = 4] = "TIMEOUT";
})(IDLE_ENUM || (IDLE_ENUM = {}));
/*
  Peers install: npm install --save @ng-idle/core @ng-idle/keepalive
  Import Module: NgIdleKeepaliveModule.forRoot()
*/
let IdleTimeoutService = class IdleTimeoutService {
    constructor(idle, keepalive, authService) {
        this.idle = idle;
        this.keepalive = keepalive;
        this.authService = authService;
        this.idleState = IDLE_ENUM.NOT_STARTED;
        this.timedOut = false;
        this.lastPing = null;
        this.defaultIdleTime = 15 * 60; // 15 minutes
    }
    start(idleTimeInSeconds = this.defaultIdleTime, timeoutInSeconds = 5, pingIntervalInSeconds = 5) {
        // sets an idle timeout of idleTimeInSeconds.
        this.idle.setIdle(idleTimeInSeconds);
        // sets a timeout period of 5 seconds. after idleTimeInSeconds + timeoutInSeconds seconds of inactivity,
        // the user will be considered timed out.
        this.idle.setTimeout(timeoutInSeconds);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        this.idle.onIdleEnd.subscribe(() => {
            this.idleState = IDLE_ENUM.NOT_IDLE;
            this.reset();
        });
        this.idle.onTimeout.subscribe(() => {
            this.idleState = IDLE_ENUM.TIMEOUT;
            this.timedOut = true;
            // Force logout on time expired
            this.authService.logout();
        });
        this.idle.onIdleStart.subscribe(() => {
            this.idleState = IDLE_ENUM.IDLE;
        });
        this.idle.onTimeoutWarning.subscribe((countdown) => {
            // this.idleState = 'You will time out in ' + countdown + ' seconds!'
            // console.log('You will time out in ' + countdown + ' seconds!');
        });
        // sets the ping interval to pingIntervalInSeconds seconds
        this.keepalive.interval(pingIntervalInSeconds);
        this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
        this.reset();
    }
    reset() {
        this.idle.watch();
        this.idleState = IDLE_ENUM.STARTED;
        this.timedOut = false;
    }
};
IdleTimeoutService.ɵfac = function IdleTimeoutService_Factory(t) { return new (t || IdleTimeoutService)(ɵngcc0.ɵɵinject(ɵngcc4.Idle), ɵngcc0.ɵɵinject(ɵngcc5.Keepalive), ɵngcc0.ɵɵinject(AuthenticationService)); };
IdleTimeoutService.ctorParameters = () => [
    { type: Idle },
    { type: Keepalive },
    { type: AuthenticationService }
];
IdleTimeoutService.ɵprov = ɵɵdefineInjectable({ factory: function IdleTimeoutService_Factory() { return new IdleTimeoutService(ɵɵinject(Idle), ɵɵinject(Keepalive), ɵɵinject(AuthenticationService)); }, token: IdleTimeoutService, providedIn: "root" });
IdleTimeoutService = __decorate([ __metadata("design:paramtypes", [Idle,
        Keepalive,
        AuthenticationService])
], IdleTimeoutService);

let CanAccessDirective = class CanAccessDirective {
    constructor(authorizationService, templateRef, viewContainer) {
        this.authorizationService = authorizationService;
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.hasView = false;
    }
    ngOnInit() {
        this.viewContainer.clear();
        this.applyAuthorities();
    }
    ngOnDestroy() {
        if (this.subscription$ != null) {
            this.subscription$.unsubscribe();
        }
    }
    applyAuthorities() {
        this.subscription$ = this.authorizationService.checkAuthorities(this.authorities)
            .subscribe((authorized) => {
            if (authorized && !this.hasView) {
                this.viewContainer.createEmbeddedView(this.templateRef);
                this.hasView = true;
            }
            else if (!authorized && this.hasView) {
                this.viewContainer.clear();
                this.hasView = false;
            }
        });
    }
};
CanAccessDirective.ɵfac = function CanAccessDirective_Factory(t) { return new (t || CanAccessDirective)(ɵngcc0.ɵɵdirectiveInject(AuthorizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
CanAccessDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CanAccessDirective, selectors: [["", "canAccess", ""]], inputs: { authorities: ["canAccess", "authorities"] } });
CanAccessDirective.ctorParameters = () => [
    { type: AuthorizationService },
    { type: TemplateRef },
    { type: ViewContainerRef }
];
__decorate([
    Input('canAccess'),
    __metadata("design:type", Object)
], CanAccessDirective.prototype, "authorities", void 0);
CanAccessDirective = __decorate([ __metadata("design:paramtypes", [AuthorizationService,
        TemplateRef,
        ViewContainerRef])
], CanAccessDirective);

let PasswordMeterComponent = class PasswordMeterComponent {
    constructor(passwordStrengthService) {
        this.passwordStrengthService = passwordStrengthService;
        this.greenTrashHold = false;
    }
    set password(password) {
        this.result = this.passwordStrengthService.checkPassword(password);
    }
    /*get status(): string {
      if (this.result == null || this.result.score == null || this.result.score <= 1) {
        return 'danger';
      }
  
      if (this.result.score === 2) {
        return 'warning';
      }
  
      return 'success';
    } */
    get status() {
        if (this.greenTrashHold) {
            if (this.result == null || this.result.score == null || this.result.score <= 1) {
                return 'danger';
            }
            if (this.result.score === 2) {
                return 'warning';
            }
            console.log('greenTrashHold from framework' + this.greenTrashHold);
            if (this.greenTrashHold) {
                return 'success';
            }
        }
        else {
            return this.withoutParameter();
        }
    }
    withoutParameter() {
        if (this.result == null || this.result.score == null || this.result.score <= 1) {
            return 'danger';
        }
        if (this.result.score === 2) {
            return 'warning';
        }
        return 'success';
    }
    get score() {
        if (this.result == null || this.result.score == null) {
            return 0;
        }
        return this.result.score * 25;
    }
};
PasswordMeterComponent.ɵfac = function PasswordMeterComponent_Factory(t) { return new (t || PasswordMeterComponent)(ɵngcc0.ɵɵdirectiveInject(PasswordStrengthService)); };
PasswordMeterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PasswordMeterComponent, selectors: [["pwc-password-meter"]], inputs: { greenTrashHold: "greenTrashHold", password: "password" }, decls: 1, vars: 1, consts: [[3, "type", "value", 4, "ngIf"], [3, "type", "value"]], template: function PasswordMeterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PasswordMeterComponent_ngb_progressbar_0_Template, 1, 2, "ngb-progressbar", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.result);
    } }, directives: [ɵngcc6.NgIf, ɵngcc7.NgbProgressbar], styles: [""] });
PasswordMeterComponent.ctorParameters = () => [
    { type: PasswordStrengthService }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], PasswordMeterComponent.prototype, "greenTrashHold", void 0);
__decorate([
    Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PasswordMeterComponent.prototype, "password", null);
PasswordMeterComponent = __decorate([ __metadata("design:paramtypes", [PasswordStrengthService])
], PasswordMeterComponent);

let CannotAccessDirective = class CannotAccessDirective {
    constructor(authorizationService, templateRef, viewContainer) {
        this.authorizationService = authorizationService;
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.hasView = false;
    }
    ngOnInit() {
        this.viewContainer.clear();
        this.applyAuthorities();
    }
    ngOnDestroy() {
        if (this.subscription$ != null) {
            this.subscription$.unsubscribe();
        }
    }
    applyAuthorities() {
        this.subscription$ = this.authorizationService.checkAuthorities(this.authorities)
            .subscribe((authorized) => {
            if (!authorized && !this.hasView) {
                this.viewContainer.createEmbeddedView(this.templateRef);
                this.hasView = true;
            }
            else if (authorized && this.hasView) {
                this.viewContainer.clear();
                this.hasView = false;
            }
        });
    }
};
CannotAccessDirective.ɵfac = function CannotAccessDirective_Factory(t) { return new (t || CannotAccessDirective)(ɵngcc0.ɵɵdirectiveInject(AuthorizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
CannotAccessDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: CannotAccessDirective, selectors: [["", "cannotAccess", ""]], inputs: { authorities: ["cannotAccess", "authorities"] } });
CannotAccessDirective.ctorParameters = () => [
    { type: AuthorizationService },
    { type: TemplateRef },
    { type: ViewContainerRef }
];
__decorate([
    Input('cannotAccess'),
    __metadata("design:type", Object)
], CannotAccessDirective.prototype, "authorities", void 0);
CannotAccessDirective = __decorate([ __metadata("design:paramtypes", [AuthorizationService,
        TemplateRef,
        ViewContainerRef])
], CannotAccessDirective);

let SecurityModule = class SecurityModule {
};
SecurityModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SecurityModule });
SecurityModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SecurityModule_Factory(t) { return new (t || SecurityModule)(); }, providers: [
        // {provide: APP_INITIALIZER, useFactory: refreshTokenInitializer, multi: true, deps: [AuthenticationService]},
        CookieService
    ], imports: [[
            CommonModule,
            UIModule
        ]] });

let AuthenticationGuard = class AuthenticationGuard {
    constructor(router, authenticationService) {
        this.router = router;
        this.authenticationService = authenticationService;
    }
    canActivate(route, state) {
        return this.canAccess(route, state);
    }
    canActivateChild(childRoute, state) {
        return this.canAccess(childRoute, state);
    }
    canAccess(route, state) {
        return this.authenticationService.cookie
            .pipe(first(), map((cookie) => {
            if (cookie != null) {
                return true;
            }
            this.authenticationService.logout(route.data.loginUrl || null);
            return false;
        }));
    }
};
AuthenticationGuard.ɵfac = function AuthenticationGuard_Factory(t) { return new (t || AuthenticationGuard)(ɵngcc0.ɵɵinject(ɵngcc8.Router), ɵngcc0.ɵɵinject(AuthenticationService)); };
AuthenticationGuard.ctorParameters = () => [
    { type: Router },
    { type: AuthenticationService }
];
AuthenticationGuard.ɵprov = ɵɵdefineInjectable({ factory: function AuthenticationGuard_Factory() { return new AuthenticationGuard(ɵɵinject(Router), ɵɵinject(AuthenticationService)); }, token: AuthenticationGuard, providedIn: "root" });
AuthenticationGuard = __decorate([ __metadata("design:paramtypes", [Router,
        AuthenticationService])
], AuthenticationGuard);

let AuthorizationGuard = class AuthorizationGuard {
    constructor(authorizationService, router) {
        this.authorizationService = authorizationService;
        this.router = router;
    }
    canActivate(next, state) {
        return this.isAuthorized(next);
    }
    canActivateChild(next, state) {
        return this.isAuthorized(next);
    }
    canLoad(route, segments) {
        if (route.data.authorities == null) {
            return true;
        }
        return this.authorizationService.checkAuthorities(route.data.authorities);
    }
    isAuthorized(route) {
        //  Route doesn't require authorities => Grant access
        if (route.data.authorities == null) {
            return of(true);
        }
        return this.authorizationService.checkAuthorities(route.data.authorities)
            .pipe(map((authorized) => {
            if (authorized) {
                return true;
            }
            if (route.data.redirect == null) {
                return false;
            }
            return this.router.createUrlTree(route.data.redirect);
        }));
    }
};
AuthorizationGuard.ɵfac = function AuthorizationGuard_Factory(t) { return new (t || AuthorizationGuard)(ɵngcc0.ɵɵinject(AuthorizationService), ɵngcc0.ɵɵinject(ɵngcc8.Router)); };
AuthorizationGuard.ctorParameters = () => [
    { type: AuthorizationService },
    { type: Router }
];
AuthorizationGuard.ɵprov = ɵɵdefineInjectable({ factory: function AuthorizationGuard_Factory() { return new AuthorizationGuard(ɵɵinject(AuthorizationService), ɵɵinject(Router)); }, token: AuthorizationGuard, providedIn: "root" });
AuthorizationGuard = __decorate([ __metadata("design:paramtypes", [AuthorizationService,
        Router])
], AuthorizationGuard);

let PasswordManagerGuard = class PasswordManagerGuard {
    constructor(authenticationService, logger) {
        this.authenticationService = authenticationService;
        this.logger = logger;
    }
    canActivate(next, state) {
        return this.canAccess(next);
    }
    canActivateChild(next, state) {
        return this.canAccess(next);
    }
    canAccess(route) {
        return this.authenticationService.mustChangePassword$
            .pipe(switchMap((mustChange) => {
            if (mustChange == null) {
                return this.authenticationService.dataUser()
                    .pipe(switchMap((data) => {
                    return this.authenticationService.mustChangePassword$;
                }));
            }
            return of(mustChange);
        }), tap((mustChange) => {
            this.logger.info('Must change password: ' + (mustChange ? 'TRUE' : 'FALSE'));
        }), map((mustChange) => {
            if (mustChange) {
                this.authenticationService.navigateToChangePassword();
                return false;
            }
            return true;
        }), catchError((err, caught) => {
            this.logger.error('PasswordManager guard error', err);
            return throwError(err);
        }));
    }
};
PasswordManagerGuard.ɵfac = function PasswordManagerGuard_Factory(t) { return new (t || PasswordManagerGuard)(ɵngcc0.ɵɵinject(AuthenticationService), ɵngcc0.ɵɵinject(ɵngcc9.NGXLogger)); };
PasswordManagerGuard.ctorParameters = () => [
    { type: AuthenticationService },
    { type: NGXLogger }
];
PasswordManagerGuard.ɵprov = ɵɵdefineInjectable({ factory: function PasswordManagerGuard_Factory() { return new PasswordManagerGuard(ɵɵinject(AuthenticationService), ɵɵinject(NGXLogger)); }, token: PasswordManagerGuard, providedIn: "root" });
PasswordManagerGuard = __decorate([ __metadata("design:paramtypes", [AuthenticationService,
        NGXLogger])
], PasswordManagerGuard);

let AutologinGuard = class AutologinGuard {
    constructor(redirectService, authenticationService, router) {
        this.redirectService = redirectService;
        this.authenticationService = authenticationService;
        this.router = router;
    }
    canActivate(next, state) {
        return this.handle(next, state);
    }
    canActivateChild(childRoute, state) {
        return this.handle(childRoute, state);
    }
    handle(next, state) {
        const token = next.queryParamMap.get('token');
        const refreshToken = next.queryParamMap.get('refresh_token');
        if (StringUtils.isEmpty(token) && StringUtils.isEmpty(refreshToken)) {
            return true;
        }
        this.authenticationService.setToken(token, refreshToken);
        return this.redirectService.navigate(state.url.split('?')[0]);
    }
};
AutologinGuard.ɵfac = function AutologinGuard_Factory(t) { return new (t || AutologinGuard)(ɵngcc0.ɵɵinject(ɵngcc3.RedirectService), ɵngcc0.ɵɵinject(AuthenticationService), ɵngcc0.ɵɵinject(ɵngcc8.Router)); };
AutologinGuard.ctorParameters = () => [
    { type: RedirectService },
    { type: AuthenticationService },
    { type: Router }
];
AutologinGuard.ɵprov = ɵɵdefineInjectable({ factory: function AutologinGuard_Factory() { return new AutologinGuard(ɵɵinject(RedirectService), ɵɵinject(AuthenticationService), ɵɵinject(Router)); }, token: AutologinGuard, providedIn: "root" });
AutologinGuard = __decorate([ __metadata("design:paramtypes", [RedirectService,
        AuthenticationService,
        Router])
], AutologinGuard);

let JwtInterceptor = class JwtInterceptor {
    constructor(authenticationService, translateService) {
        this.authenticationService = authenticationService;
        this.translateService = translateService;
    }
    intercept(request, next) {
        if (request.url.indexOf('/oauth/token') > -1) {
            // Prevent Authorization header override when refreshing token.
            return next.handle(request);
        }
        // TODO: get language from I18nService (see 2086)
        // add authorization header with jwt token if available
        const currentUser = this.authenticationService.cookieValue;
        const lang = this.translateService.currentLang != null ? this.translateService.currentLang : 'it';
        if (currentUser && currentUser.access_token) {
            const headers = new HttpHeaders({
                Authorization: `Bearer ${currentUser.access_token}`,
                'Accept-Language': `${lang.toLowerCase()}-${lang.toUpperCase()}`,
                'Content-Type': 'application/json'
            });
            const conf = request.url.endsWith('.json') ? {} : { headers };
            request = request.clone(conf);
        }
        return next.handle(request);
    }
};
JwtInterceptor.ɵfac = function JwtInterceptor_Factory(t) { return new (t || JwtInterceptor)(ɵngcc0.ɵɵinject(AuthenticationService), ɵngcc0.ɵɵinject(ɵngcc10.TranslateService)); };
JwtInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: JwtInterceptor, factory: JwtInterceptor.ɵfac });
JwtInterceptor.ctorParameters = () => [
    { type: AuthenticationService },
    { type: TranslateService }
];
JwtInterceptor = __decorate([ __metadata("design:paramtypes", [AuthenticationService,
        TranslateService])
], JwtInterceptor);

let ErrorInterceptor = class ErrorInterceptor {
    constructor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    intercept(request, next) {
        return next.handle(request).pipe(catchError(err => {
            const oauth = request.url.indexOf('/oauth/token');
            const isNotLogoutCall = request.url.indexOf(this.authenticationService.LOGOUT_ENDPOINT) === -1;
            if (isNotLogoutCall && oauth === -1 &&
                (err.status === 401 || err.status === 400 && err.error.error === 'invalid_grant')) {
                // Attempt a refresh token.
                this.authenticationService.logout();
            }
            console.log('ErrorInterceptor - catchError');
            // const error = err.error.message || err.statusText;
            return throwError(err);
        }));
    }
};
ErrorInterceptor.ɵfac = function ErrorInterceptor_Factory(t) { return new (t || ErrorInterceptor)(ɵngcc0.ɵɵinject(AuthenticationService)); };
ErrorInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ErrorInterceptor, factory: ErrorInterceptor.ɵfac });
ErrorInterceptor.ctorParameters = () => [
    { type: AuthenticationService }
];
ErrorInterceptor = __decorate([ __metadata("design:paramtypes", [AuthenticationService])
], ErrorInterceptor);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.CookieService }, { type: ɵngcc3.CacheService }, { type: ɵngcc3.RedirectService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['AUTH_OPTIONS']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthorizationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc3.SocietiesService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['AUTH_OPTIONS']
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PasswordStrengthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CryptoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [CRYPTO_PARAMS]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PasswordValidationFrontendService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IdleTimeoutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc4.Idle }, { type: ɵngcc5.Keepalive }, { type: AuthenticationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CanAccessDirective, [{
        type: Directive,
        args: [{
                selector: '[canAccess]'
            }]
    }], function () { return [{ type: AuthorizationService }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }]; }, { authorities: [{
            type: Input,
            args: ['canAccess']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PasswordMeterComponent, [{
        type: Component,
        args: [{
                selector: 'pwc-password-meter',
                template: "<ngb-progressbar *ngIf=\"result\"\n                 [type]=\"status\"\n                 [value]=\"score\"></ngb-progressbar>\n",
                styles: [""]
            }]
    }], function () { return [{ type: PasswordStrengthService }]; }, { greenTrashHold: [{
            type: Input
        }], password: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CannotAccessDirective, [{
        type: Directive,
        args: [{
                selector: '[cannotAccess]'
            }]
    }], function () { return [{ type: AuthorizationService }, { type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }]; }, { authorities: [{
            type: Input,
            args: ['cannotAccess']
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SecurityModule, { declarations: function () { return [CanAccessDirective,
        CannotAccessDirective,
        PasswordMeterComponent]; }, imports: function () { return [CommonModule,
        UIModule]; }, exports: function () { return [CanAccessDirective,
        CannotAccessDirective,
        PasswordMeterComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SecurityModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CanAccessDirective,
                    CannotAccessDirective,
                    PasswordMeterComponent
                ],
                imports: [
                    CommonModule,
                    UIModule
                ],
                providers: [
                    // {provide: APP_INITIALIZER, useFactory: refreshTokenInitializer, multi: true, deps: [AuthenticationService]},
                    CookieService
                ],
                exports: [
                    CanAccessDirective,
                    CannotAccessDirective,
                    PasswordMeterComponent
                ]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthenticationGuard, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc8.Router }, { type: AuthenticationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthorizationGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AuthorizationService }, { type: ɵngcc8.Router }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PasswordManagerGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AuthenticationService }, { type: ɵngcc9.NGXLogger }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AutologinGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.RedirectService }, { type: AuthenticationService }, { type: ɵngcc8.Router }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(JwtInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthenticationService }, { type: ɵngcc10.TranslateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ErrorInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AuthenticationService }]; }, null); })();

/*
 * Public API Surface of security
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthenticationCookie, AuthenticationGuard, AuthenticationService, AuthorizationGuard, AuthorizationService, AutologinGuard, CRYPTO_PARAMS, CanAccessDirective, CryptoService, ErrorInterceptor, IDLE_ENUM, IdleTimeoutService, JwtInterceptor, PasswordManagerGuard, PasswordMeterComponent, PasswordStrengthService, PasswordValidationFrontendService, SecurityModule, AuthorizationService as ɵa, CannotAccessDirective as ɵb, PasswordStrengthService as ɵc };

//# sourceMappingURL=pwc-security.js.map